import React from 'react';
import { Promo } from '~/components/generic/Promo';
import { promoMaterials } from '~/screens/ApiScreen/FeedApi/components/EmptyScreen/consts';
import { emptyScreenButtonsCreator } from '~/screens/ApiScreen/FeedApi/components/EmptyScreen/emptyScreenButtonsCreator';

interface IEmptyScreenProps {
  hasRight: boolean;
}

const EmptyScreen: React.FC<IEmptyScreenProps> = ({ hasRight }) => {
  const { header, img, items, subheader, text1 } = promoMaterials;

  return (
    <Promo
      actions={emptyScreenButtonsCreator(hasRight)}
      header={header}
      img={img}
      items={items}
      subheader={subheader}
      text1={text1}
    />
  );
};

export default EmptyScreen;